import get from 'lodash/get';

const REGEX = /["a-zA-Z-0-9.:,()ÀÂÇÈÉÊËÎÔÙÛàâçèéêëîôöùû+=><_°&%  /’'–-]{1,100}/gm;

function genererDefaultAdresse() {
  return {
    adresse1: null,
    adresse2: null,
    adresse3: null,
    pays: null,
    ville: null,
    codePostal: null,
    departement: null,
    agglomeration: null,
    intitule1: null,
    intitule2: null,
    intitule3: null,
    latitude: null,
    longitude: null,
    coordonnees: null,
  };
}

function getCoordonneesByAdresse(adresse) {
  if (!adresse) return { lat: 0, lng: 0 };
  if (adresse.coordonnees) return adresse.coordonnees;
  return { lat: adresse.latitude, lng: adresse.longitude };
}

function addressStringBase(address) {
  if (!address) return '';
  const addressBase1 = [
    address.adresse1,
    address.adresse2,
    address.adresse3,
  ].filter(Boolean).join(' ');
  return addressBase1;
}

export function getAdresseByGescomAdresse(adresse) {
  if (!adresse) return genererDefaultAdresse();
  return {
    ...adresse,
    coordonnees: getCoordonneesByAdresse(adresse),
  }
}

export function adressFullStringGetter(adresse) {
  if (!adresse) return '';
  const adresseBase2 = [
    adresse.codePostal,
    adresse.ville,
  ].filter(Boolean).join(' ');
  return [addressStringBase(adresse), adresseBase2].filter(Boolean).join(', ');
}

export default function adresseGenerer(adresse) {
  if (!adresse) return genererDefaultAdresse();
  let libelleAdresse =  adresse.adresse1;
  if (!libelleAdresse) {
    libelleAdresse = [adresse.numberRue, adresse.libelleRue].filter(libelle => !!libelle).join(', ') || adresse.libelle;
  }

  const match = [libelleAdresse, adresse.adresse2,
    adresse.adresse3].filter(libelle => !!libelle).join(', ').match(REGEX);
  return {
    ...genererDefaultAdresse(),
    intitule1: match && match.length >= 1 ? match[0] : '',
    adresse1: match && match.length >= 1 ? match[0] : '',
    adresse2:  match && match.length >= 2 ? match[1] : '',
    adresse3:  match && match.length >= 3 ? match[2] : '',
    pays: adresse.pays,
    ville: adresse.ville ? adresse.ville : adresse.pays,
    codePostal: adresse.codePostal,
    latitude: get(adresse.coordonnees, 'lat'),
    longitude: get(adresse.coordonnees, 'lng'),
    coordonnees: adresse.coordonnees,
  };
}
